jQuery($ => {
	$('#footer .footer-3 .footer-logo-carousel').each(function () {
		const $carouselWrapper = $(this);
		$carouselWrapper.owlCarousel({
			margin: 48,
			items: 1.75,
			nav: false,
			loop: true,
			dots: false,
			autoWidth: true,
		});
	});
});
